import { AxiosError } from 'axios';

const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again.';

type ErrorHandler = (message: string) => void;
let handler: ErrorHandler | null = null;

export const registerErrorHandler = (h: ErrorHandler) => {
  handler = h;
};

export const notifyError = (message: string) => {
  handler?.(message);
};

export function extractErrorMessage(error: unknown): string {
  if (error instanceof AxiosError) {
    const serverMessage =
      error.response?.data?.message || error.response?.data?.error;
    if (typeof serverMessage === 'string' && serverMessage.length > 0) {
      return serverMessage;
    }
    if (error.message) return error.message;
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  if (typeof error === 'string' && error.length > 0) {
    return error;
  }

  return DEFAULT_ERROR_MESSAGE;
}
